import React, { Component, useEffect } from 'react';

import CoachLayout from '../CoachLayout/CoachLayout';
import CommonService from '../../../../services/commonService';
import { KuposButton } from '../../../common';
import KuposSelectBox from '../../../common/KuposSelectBox';
import TrainCoachLayout from '../TrainCoachLayout/TrainCoachLayout';

// import PropTypes from 'prop-types';
// import ReactDOM from 'react-dom';

// import DateService from '../../../../services/dateService';
// import DropdownComponent from '../../common/DropdownComponent';

function SelectedServiceMore(props) {
  let seatTypeMouseoverDivEl = {};

  console.log('petSeats', props.petSeats);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = event => { };

  const isSeatType = type => {
    // console.log('Seats bottom strip------------', type);
    // eslint-disable-next-line
    if (CommonService.isTrain() || props.serviceDetails.travel_id == 272) {
      for (let wLayout of props.coachLayout) {
        for (let row of wLayout) {
          for (let seat of row) {
            // console.log('Seat is-----------------', seat);
            if (seat.type.toUpperCase() === type && seat.number.toUpperCase().indexOf('GY') < 0) {
              return true;
            }
          }
        }
      }
    } else {
      for (let row of props.coachLayout) {
        for (let seat of row) {
          if (seat.type.toUpperCase() === type && seat.number.toUpperCase().indexOf('GY') < 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const getSeatType = (text, icon) => {
    console.log('seatTypeIs---', text);
    let seatMessage =
      text === 'Mascota a bordo'
        ? props.t('TRANSLATIONS.PET_SEAT_INFO')
        : text === 'Semi Cama'
          ? props.t('TRANSLATIONS.SEMI_CAMA_SEAT_INFO')
          : props.t('TRANSLATIONS.GENERAL_SEAT_INFO');
    return (
      <div className="seat-type-icon">
        <img src={icon} />
        {text}
        <div
          className="mouseover-popups seat-type-mouseover"
          key={text + Math.random()}
          ref={el => {
            seatTypeMouseoverDivEl[text] = el;
          }}
          style={{
            marginLeft:
              '-' +
              (seatTypeMouseoverDivEl[text] ? seatTypeMouseoverDivEl[text].clientWidth / 2 : 0) +
              'px',
          }}
        >
          <span className="font9 bold-text upper-case-text">{text}</span>
          <span className="font9">{seatMessage}</span>
        </div>
      </div>
    );
  };

  let { t } = props;
  let boardingOptions = [];

  props.boardingOptions.map(op => {
    let labelRaw = op.name + ' - ' + op.time;
    boardingOptions.push({
      value: op.id,
      label: labelRaw,
    });
  });

  let droppingOptions = [];
  for (let op of props.droppingOptions) {
    let labelRaw = op.name + ' - ' + op.time;
    droppingOptions.push({
      value: op.id,
      label: labelRaw,
    });
  }
  let selectedBoarding = null;
  if (props.selectedBoarding) {
    selectedBoarding = {
      value: props.selectedBoarding.id,
      label: props.selectedBoarding.name + ' - ' + props.selectedBoarding.time,
    };
  }
  let selectedDropping = null;
  if (props.selectedDropping) {
    selectedDropping = {
      value: props.selectedDropping.id,
      label: props.selectedDropping.name + ' - ' + props.selectedDropping.time,
    };
  }

  const hasPetSeats = () => {
    if (props.petSeats) {
      if (Object.keys(props.petSeats).length > 0) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className="pb-service-list-selected-service-more service-card-more-details">
      <div className="close-btn flex-row">
        <img onClick={props.closeLayout} src="/images/icons/close-window.svg" />
      </div>
      <div className="flex-row select-row">
        <div className="select-item font10">
          <span className="select-label font11 black-text">{t('RESULTS_PAGE.BOARDING_POINT3')}</span>
          {/* <div className="select-box flex-row kupos-border">
                    <img className="icon-source" src="/images/icons/home/icon_source.png"/>
                    <span>Terminal de buses Carlos Oviedo</span>
                    <img className="icon-arrow" src="/images/icons/icon-arrow.png"/>
                </div> */}
          <KuposSelectBox
            options={boardingOptions}
            selectedOption={
              boardingOptions.length > 0 && props.selectedBoarding && props.selectedBoarding.id
                ? selectedBoarding
                : null
            }
            // selectedOption={isNull(selectedBoarding) ? null : selectedBoarding}
            onChange={props.onBoardingPointChange}
            placeholder={t('RESULTS_PAGE.BOARDING_POINT3')}
            icon="/images/search-bar/search-bar-origin.svg"
            height={44}
            readonly={true}
            error={props.boardingErrorMessage ? true : false}
            errorMessage={props.boardingErrorMessage}
            t={t}
            showAll={true}
            key={
              props.boardingOptions && props.boardingOptions.length
                ? props.boardingOptions.length > 1
                  ? props.boardingOptions.length +
                  props.boardingOptions[1].id +
                  props.boardingOptions[1].time
                  : props.boardingOptions.length +
                  props.boardingOptions[0].id +
                  props.boardingOptions[0].time
                : ''
            }
            noOptions={boardingOptions && boardingOptions.length === 1}
          />
        </div>
        <div className="select-item font10">
          <span className="select-label font11 black-text ">
            {t('RESULTS_PAGE.DROP_OFF_POINT')}
          </span>

          <KuposSelectBox
            options={droppingOptions}
            selectedOption={droppingOptions.length > 0 ? selectedDropping : null}
            onChange={props.onDroppingPointChange}
            placeholder={t('RESULTS_PAGE.DROP_OFF_POINT3')}
            icon="/images/search-bar/search-bar-destination.svg"
            height={44}
            readonly={true}
            error={props.droppingErrorMessage ? true : false}
            errorMessage={props.droppingErrorMessage}
            key={
              props.droppingOptions && props.droppingOptions.length
                ? props.droppingOptions.length > 1
                  ? props.droppingOptions.length +
                  props.droppingOptions[1].id +
                  props.droppingOptions[1].time
                  : props.droppingOptions.length +
                  props.droppingOptions[0].id +
                  props.droppingOptions[0].time
                : ''
            }
            t={t}
            noOptions={droppingOptions && droppingOptions.length === 1}
          />
        </div>
      </div>
      <CoachLayout
        metaData={props.metaData}
        coachLayout={props.coachLayout}
        upperAvalibility={props.upperAvalibility}
        selectedSeatsToBook={props.selectedSeatsToBook}
        onFloorChange={props.onFloorChange}
        selectedFloor={props.selectedFloor}
        onSeatSelect={props.onSeatSelect}
        selectedService={props.selectedService}
        t={t}
        petSeats={props.petSeats}
        isMot={props.isMot}
        motMaxSeatError={props.motMaxSeatError}
      />
      <div className="continue-button-row flex-row">
        <div className="flex-row seat-types dark-text font10">
          {isSeatType('CLASICO')
            ? getSeatType('Clásico', '/images/seats/icon-seat-legend_executive.png')
            : null}
          {isSeatType('EJECUTIVO')
            ? getSeatType('Ejecutivo', '/images/seats/icon-seat-legend_executive.png')
            : null}
          {isSeatType('SEMI CAMA')
            ? getSeatType('Semi Cama', '/images/seats/icon-seat-legend_semi-bed.png')
            : null}
          {isSeatType('PREMIUM')
            ? getSeatType('Premium', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('SALON CAMA')
            ? getSeatType('Salón Cama', '/images/seats/icon-seat-legend_salon-cama.png')
            : null}
          {isSeatType('SALON SIN VENT')
            ? getSeatType('Salón Sin Vent', '/images/seats/icon-seat-legend_salon-cama.png')
            : null}
          {isSeatType('PREFERENTE')
            ? getSeatType('Preferente', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('CAMA PREMIUM')
            ? getSeatType('Cama Premium', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('CAMA SUITE')
            ? getSeatType('Cama Suite', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('PREMIUM PROMO')
            ? getSeatType('Premium Promo', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('CAMA VIP')
            ? getSeatType('Cama Vip', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType('SUITE CAMA')
            ? getSeatType('Suite Cama', '/images/seats/icon-seat-legend_vip.png')
            : null}
          {isSeatType("SALON CAMA IND")
            ? getSeatType('Salón Cama IND', '/images/seats/icon-seat-legend_salon-cama.png')
            : null}
          {isSeatType("SALON CAMA P")
            ? getSeatType('Salón Cama P', '/images/seats/icon-seat-legend_salon-cama.png')
            : null}
          {isSeatType('BIO BIO SUPERIOR')
            ? getSeatType('Bio Bio Superior', '/images/seats/icon-seat-legend_salon-cama.png')
            : null}
          {hasPetSeats()
            ? getSeatType('Mascota a bordo', '/images/seats/icon-seat-legend_pet.png')
            : null}
        </div>
        <div className="continue-button font12 d-flex flex-column align-items-center">
          <KuposButton
            disabled={!props.selectedSeatsToBook || props.selectedSeatsToBook.length <= 0 || props.confirmLoader}
            onClick={props.onContinueButtonClick}
          >

            {props.confirmLoader ? (
              <div className="loader-cricle"></div>
            ) : (
              t('RESULTS_PAGE.CONTINUE') +
              ': ' +
              (props.bookingDetails
                ? CommonService.currency(props.bookingDetails.netBookingAmount).split(',')[0]
                : '')
            )}
          </KuposButton>
          <p className="margin-T10 font11">
            {t('RESULTS_PAGE.SELECTED_SEATS')}:&nbsp;
            <span className="black-text">
              {!props.selectedSeatsToBook ? 0 : props.selectedSeatsToBook.length}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SelectedServiceMore;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/SelectedServiceMore/SelectedServiceMore.js